import { render, staticRenderFns } from "./UploadedFile.vue?vue&type=template&id=2905808e&scoped=true&"
import script from "./UploadedFile.vue?vue&type=script&lang=js&"
export * from "./UploadedFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFile.vue?vue&type=style&index=0&id=2905808e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2905808e",
  null
  
)

export default component.exports